/**
 * NearU Feature Flags
 * ====================
 * Central configuration for enabling/disabling features.
 * Set flags to false to show "Coming Soon" states.
 */

export const FEATURES = {
  // Paid membership tiers (Gold, Diamond)
  // Set to false to disable checkout/payment and show "Coming Soon"
  paidMemberships: false,
  
  // Identity verification / KYC
  identityVerification: true,
  
  // NearU Card functionality
  nearuCard: true,
  
  // Proximity discovery
  proximity: true,
  
  // Gift sending - Set to false to disable all gifting flows
  gifting: false,
  
  // AI Concierge
  aiConcierge: false,
  
  // Apple Wallet integration
  appleWallet: false,
  
  // Real-time chat
  messaging: true,
};

export default FEATURES;
